// extracted by mini-css-extract-plugin
export default {"layout":"pageLayout_layout__0O+NB"};